export default __webpack_public_path__ + "static/media/blumeattempt-justlikeyou-04.1445aece.jpg";